import { localeNamespace, TLocale } from '@internal/utils/machine/i18n/Locale';
import { Close } from '@mui/icons-material';
import { Alert, Snackbar, SnackbarOrigin } from '@renderer-ui-library/mui';
import { translations } from 'i18n/translations';
import { useTranslation } from 'next-i18next';
import React, { useCallback, useContext } from 'react';
import styles from './compareMachinesAlerts.module.scss';
import { MachineComparisonContext } from './MachineComparisonContext';

const anchorOrigin: SnackbarOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
};
export const CompareMachinesAlerts: React.FC<{ locale: TLocale }> = React.memo(
    _props => {
        const { comparisonAlertType, dismissAlert } = useContext(
            MachineComparisonContext,
        );
        const { t } = useTranslation(localeNamespace.common);

        const handleCloseClick = useCallback(
            (_event: React.SyntheticEvent | Event, reason?: string) => {
                if (reason === 'clickaway') {
                    return;
                }

                dismissAlert();
            },
            [dismissAlert],
        );

        return (
            <>
                <Snackbar
                    open={comparisonAlertType === 'reachedMaxMachines'}
                    autoHideDuration={4000}
                    onClose={handleCloseClick}
                    anchorOrigin={anchorOrigin}
                >
                    <Alert
                        icon={false}
                        sx={{ width: '100%' }}
                        className={styles.alert}
                    >
                        {t(
                            translations.compareMachinesAlertMaximumMachineToCompare,
                        )}

                        <Close
                            fontSize="small"
                            className={styles.icon}
                            onClick={handleCloseClick}
                        />
                    </Alert>
                </Snackbar>

                <Snackbar
                    open={comparisonAlertType === 'changedMachineType'}
                    autoHideDuration={4000}
                    onClose={handleCloseClick}
                    anchorOrigin={anchorOrigin}
                >
                    <Alert
                        icon={false}
                        sx={{ width: '100%' }}
                        className={styles.alert}
                    >
                        {t(
                            translations.compareMachinesAlertCompareOnlySameMachineType,
                        )}

                        <Close
                            fontSize="small"
                            className={styles.icon}
                            onClick={handleCloseClick}
                        />
                    </Alert>
                </Snackbar>
            </>
        );
    },
);

CompareMachinesAlerts.displayName = 'CompareMachinesAlerts';
